import React from 'react';
import { TrialInputProps } from '~/common/types';
import { Input } from '~/common/components/Input';
import { validateEmail } from '~/common/util/customValidation';
import { Field } from 'formik';
import styles from '../Grid.module.css';
import { trackBlur } from '~/common/util/trackBlur';
import { TRIAL_TYPES } from '~/common/consts';

export const EmailOnlyInput = (props: TrialInputProps) => {
  const {
    formikTouched,
    formikErrors,
    inputs,
    showHint,
    trackErrorBlur,
    validateBusinessEmail,
    existingAccount,
    userEmail,
    existingEmailError,
    mistypedEmailError,
  } = props;

  const { email } = inputs;

  const { trialType } = window.LPFormData;

  return (
    <div className={`${styles.inputGrid} ${styles.trial}`}>
      {!userEmail ? (
        <Field
          name={email.id}
          type={'email'}
          error={formikErrors[email.id] && formikTouched[email.id]}
          errormessage={
            mistypedEmailError
              ? `${email.placeHolder} ${mistypedEmailError}`
              : existingAccount
                ? existingEmailError
                : email.error
          }
          showHint={showHint}
          hintmessage={email.placeHolder}
          validate={validateEmail}
          as={Input}
          label={email.label}
          maxLength={128}
          onFocus={() => {
            trackBlur(email.id);
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            trialType !== TRIAL_TYPES.PREMIUM && trialType !== TRIAL_TYPES.FAMILIES
              ? validateBusinessEmail(event.target.value)
              : validateEmail(event.target.value);
            trackErrorBlur(email.id, validateEmail, event.target.value);
          }}
          autoFocus={true}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};
